module.exports = __webpack_public_path__ + "img/95.28006511.jpg";